"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelersMsgStatusCd = exports.TravelersRoofTypeEnum = exports.TravelersRoofGeometryTypeEnum = exports.TravelersSidingTypesEnum = exports.TravelersGarageTypesEnum = exports.TravelersNumStoriesEnum = exports.TravelersFoundationTypesEnum = exports.TravelersCoverageCodesEnum = exports.TravelersConstructionTypesEnum = void 0;
var TravelersConstructionTypesEnum;
(function (TravelersConstructionTypesEnum) {
    TravelersConstructionTypesEnum["masonry"] = "MY";
    TravelersConstructionTypesEnum["frame"] = "F";
    TravelersConstructionTypesEnum["mobileManufactured"] = "MOBILE";
    TravelersConstructionTypesEnum["concrete"] = "Pconcrete";
    TravelersConstructionTypesEnum["logHome"] = "L";
    TravelersConstructionTypesEnum["steel"] = "Steel";
    TravelersConstructionTypesEnum["modular"] = "P";
})(TravelersConstructionTypesEnum || (exports.TravelersConstructionTypesEnum = TravelersConstructionTypesEnum = {}));
var TravelersCoverageCodesEnum;
(function (TravelersCoverageCodesEnum) {
    TravelersCoverageCodesEnum["dwelling"] = "DWELL";
    TravelersCoverageCodesEnum["otherStructures"] = "OS";
    TravelersCoverageCodesEnum["personalProperty"] = "PP";
    TravelersCoverageCodesEnum["lossOfUse"] = "LOU";
    TravelersCoverageCodesEnum["personalLiability"] = "PL";
    TravelersCoverageCodesEnum["medicalPayments"] = "MEDPM";
})(TravelersCoverageCodesEnum || (exports.TravelersCoverageCodesEnum = TravelersCoverageCodesEnum = {}));
var TravelersFoundationTypesEnum;
(function (TravelersFoundationTypesEnum) {
    TravelersFoundationTypesEnum["basement"] = "BS";
    TravelersFoundationTypesEnum["slab"] = "Slab";
})(TravelersFoundationTypesEnum || (exports.TravelersFoundationTypesEnum = TravelersFoundationTypesEnum = {}));
var TravelersNumStoriesEnum;
(function (TravelersNumStoriesEnum) {
    TravelersNumStoriesEnum["oneStory"] = "1";
    TravelersNumStoriesEnum["oneAndHalfStories"] = "1H";
    TravelersNumStoriesEnum["twoStories"] = "2";
    TravelersNumStoriesEnum["twoAndHalfStories"] = "2H";
    TravelersNumStoriesEnum["threeStories"] = "3";
    TravelersNumStoriesEnum["fourOrMoreStories"] = "4";
})(TravelersNumStoriesEnum || (exports.TravelersNumStoriesEnum = TravelersNumStoriesEnum = {}));
var TravelersGarageTypesEnum;
(function (TravelersGarageTypesEnum) {
    TravelersGarageTypesEnum["attached"] = "Frame";
    TravelersGarageTypesEnum["basement"] = "BS";
    TravelersGarageTypesEnum["builtIn"] = "BI";
})(TravelersGarageTypesEnum || (exports.TravelersGarageTypesEnum = TravelersGarageTypesEnum = {}));
var TravelersSidingTypesEnum;
(function (TravelersSidingTypesEnum) {
    TravelersSidingTypesEnum["adobe"] = "ADOBE";
    TravelersSidingTypesEnum["brickVeneer"] = "BrkVen";
    TravelersSidingTypesEnum["cementFiber"] = "CementF";
    TravelersSidingTypesEnum["clapboard"] = "Clapboard";
    TravelersSidingTypesEnum["log"] = "LodCed";
    TravelersSidingTypesEnum["steelOrAluminum"] = "A";
    TravelersSidingTypesEnum["stoneVeneer"] = "StoneVen";
    TravelersSidingTypesEnum["stucco"] = "S";
    TravelersSidingTypesEnum["vinylSiding"] = "I";
    TravelersSidingTypesEnum["woodSiding"] = "WoodSid";
})(TravelersSidingTypesEnum || (exports.TravelersSidingTypesEnum = TravelersSidingTypesEnum = {}));
var TravelersRoofGeometryTypeEnum;
(function (TravelersRoofGeometryTypeEnum) {
    TravelersRoofGeometryTypeEnum["complex"] = "COMPLEX";
    TravelersRoofGeometryTypeEnum["flat"] = "FLAT";
    TravelersRoofGeometryTypeEnum["gable"] = "GABLE";
    TravelersRoofGeometryTypeEnum["gambrel"] = "GAMBREL";
    TravelersRoofGeometryTypeEnum["hip"] = "HIP";
    TravelersRoofGeometryTypeEnum["shed"] = "SHED";
})(TravelersRoofGeometryTypeEnum || (exports.TravelersRoofGeometryTypeEnum = TravelersRoofGeometryTypeEnum = {}));
var TravelersRoofTypeEnum;
(function (TravelersRoofTypeEnum) {
    TravelersRoofTypeEnum["architecturalShingle"] = "ARCH";
    TravelersRoofTypeEnum["asphaltShingle"] = "ASPHS";
    TravelersRoofTypeEnum["clay"] = "CLAY";
    TravelersRoofTypeEnum["composition"] = "COMPW";
    TravelersRoofTypeEnum["metal"] = "METL";
    TravelersRoofTypeEnum["slate"] = "SLAT";
    TravelersRoofTypeEnum["tarAndGravel"] = "TARGRB";
    TravelersRoofTypeEnum["wood"] = "WOODSS";
})(TravelersRoofTypeEnum || (exports.TravelersRoofTypeEnum = TravelersRoofTypeEnum = {}));
var TravelersMsgStatusCd;
(function (TravelersMsgStatusCd) {
    TravelersMsgStatusCd["error"] = "ERROR";
    TravelersMsgStatusCd["rejected"] = "REJECTED";
    TravelersMsgStatusCd["success"] = "SUCCESS";
})(TravelersMsgStatusCd || (exports.TravelersMsgStatusCd = TravelersMsgStatusCd = {}));
